import React, { memo } from 'react'

import RuleNodeHandle from './RuleNodeHandle'
import PlusBox from './PlusBox'

const PlusNode = ({ data }) => {
  return (
    <div>
      <PlusBox hover={data.hover} />
      {!data.initial ? <RuleNodeHandle target /> : null}
    </div>
  )
}

export default memo(PlusNode)
